/*eslint-disable*/
import React from 'react';
import { useFormikContext, useField } from 'formik';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
export const DateData = ({ ...props }) => {

    const { setFieldValue } = useFormikContext()
    const [field] = useField(props);

    return (
        <>
            <DatePicker
                {...field}
                {...props}
                selected={(field.value && new Date(field.value)) || null}
                onChange={val => {
                    setFieldValue(field.name, val);
                    if(props.updateOnChangeName){
                        let offset = props.updateOnChangeValueOffsetDays ? props.updateOnChangeValueOffsetDays : 0;
                        setFieldValue(props.updateOnChangeName, moment(val).add(offset, 'days'));
                    }
                }}
            /> 
        </>
    )
}
